export default __webpack_public_path__ + "static/bbq-full-02-11388a862335c8006c7dc1b6b649d9de.jpg";